import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { getPatientId, getPatientInfo } from "../utils/patientSession";

/**
 * Current patient for this tab. Prefer the URL, then Redux (in-memory, per tab),
 * then sessionStorage. Never use localStorage — it is shared across tabs.
 */
export const useCurrentPatientId = (): string => {
  const params = useParams();
  const reduxPatientId = useSelector(
    (state: RootState) => state.patient.patientDetails?.data?.patient_id,
  );

  return (
    params.patientId ||
    params.patient_id ||
    params.id ||
    reduxPatientId ||
    getPatientId() ||
    ""
  );
};

export const useCurrentPatientInfo = () => {
  const patientDetails = useSelector(
    (state: RootState) => state.patient.patientDetails?.data,
  );

  return useMemo(() => {
    if (patientDetails) {
      return {
        ...patientDetails,
        disease: patientDetails.disease || "",
        medicalCondition: patientDetails.medical_condition_name || "",
      };
    }

    return getPatientInfo();
  }, [patientDetails]);
};
